import { B2bInvestorProfileList } from '@sh4res/bo-common/resources/investor_profile/B2bInvestorProfileList';
import { B2bInvestorProfileShow } from '@sh4res/bo-common/resources/investor_profile/B2bInvestorProfileShow';
import { ResourceDefinitionCommon } from '@sh4res/bo-common/utils';

export const b2bInvestorProfile: ResourceDefinitionCommon = {
  options: { label: 'resources.bo_common.b2b.investor_profile.menu.investor_profile' },
  list: B2bInvestorProfileList,
  show: B2bInvestorProfileShow,
};
